import React, { useEffect } from "react";
import successImage from "assets/cm_enroll_success.png";

export const VerificationSuccess = () => {

  useEffect(() => {
    const timeout = setTimeout(() => {
      window.location.reload();
    }, 3000);

    return () => clearTimeout(timeout);
  }, []);

  return (
    <div>
      <img src={successImage} alt="Success" style={{ width: 64, height: 64 }}/>
      <h1 className="text-2xl font-bold mt-2">
            Verification success!
      </h1>
      <p className="mt-2">
        Thank you for verifying. You are now being redirected to your credit monitoring dashboard.
      </p>
    </div>
  );
};